/*到款记录 */
import { $http, buildHeaders } from "./index";

//获取列表
export const bankReceipt_page = (params) => {
  return $http.get("/admin/BankReceipt/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const bankReceipt_detail = (id) => {
  return $http.get("/admin/BankReceipt/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const bankReceipt_add = (data) => {
  return $http.post("/admin/BankReceipt/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const bankReceipt_edit = (data) => {
  return $http.post("/admin/BankReceipt/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const bankReceipt_delete = (id) => {
  return $http.post(
    "/admin/BankReceipt/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//作废
export const bankReceipt_cancel = (id) => {
  return $http.post(
    "/admin/BankReceipt/cancel",
    { id },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//冻结
export const bankReceipt_freeze = (id) => {
  return $http.post(
    "/admin/BankReceipt/freeze",
    { id },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};


//撤回银行到款认领
export const bankReceipt_backCollected = (meeting_collected_record_id) => {
  return $http.post(
    "/admin/BankReceipt/backCollected",
    { meeting_collected_record_id },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};
